module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [_c('div', [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', _vm._l((_vm.merchList), function(pro) {
    return _c('li', [_c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "my-checkbox"
      }
    }), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-after",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, _vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_c('div', {
      staticStyle: {
        "height": "1.6rem"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMin))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])]), _vm._v(" "), _vm._m(1, true)])])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "font-size": ".5rem"
    }
  }, [_c('span', {
    staticClass: "sub-span"
  }, [_vm._v("现货")]), _vm._v(" "), _c('span', {
    staticClass: "sub-span"
  }, [_vm._v("减券")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bfec4ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finder/components/NewMerchandiseListC.vue
// module id = 1653
// module chunks = 8